import { useTheme } from "../../contexts/ThemeContext";
import { Sun, Moon } from "lucide-react";
import { Button } from "./button";

export const ThemeToggle = ({ className = "" }) => {
  const { theme, toggleTheme, isDark } = useTheme();

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleTheme}
      className={`relative h-9 w-9 rounded-lg transition-all duration-200 ${className}`}
      title={isDark ? "Switch to light mode" : "Switch to dark mode"}
      data-testid="theme-toggle"
    >
      {/* Sun icon - visible in dark mode */}
      <Sun 
        className={`h-5 w-5 transition-all duration-300 absolute ${
          isDark 
            ? 'rotate-0 scale-100 opacity-100' 
            : 'rotate-90 scale-0 opacity-0'
        }`}
        style={{ color: 'var(--brand-accent-light)' }}
      />
      {/* Moon icon - visible in light mode */}
      <Moon 
        className={`h-5 w-5 transition-all duration-300 absolute ${
          isDark 
            ? '-rotate-90 scale-0 opacity-0' 
            : 'rotate-0 scale-100 opacity-100'
        }`}
        style={{ color: 'var(--text-secondary)' }}
      />
      <span className="sr-only">Toggle theme</span>
    </Button>
  );
};

export default ThemeToggle;
